/**
 * A car seen from above, pointing up (north) - the outline drawing used on
 * the live map. The parent rotates it to the heading.
 */
const TopDownCar = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 96 96" style={{ display: 'block' }}>
    <path d="M48 0 L36 22 L60 22 Z" fill="rgba(27,77,228,0.28)" />
    <g transform="translate(16 0)">
      <path d="M13 34 L6 30" stroke="#111" strokeWidth="3.2" strokeLinecap="round" fill="none" />
      <path d="M51 34 L58 30" stroke="#111" strokeWidth="3.2" strokeLinecap="round" fill="none" />
      <rect x="12" y="6" width="40" height="84" rx="17" ry="17" fill="#fff" stroke="#111" strokeWidth="3.2" />
      <ellipse cx="21" cy="15" rx="2.6" ry="4.2" transform="rotate(-35 21 15)" fill="none" stroke="#111" strokeWidth="2.6" />
      <ellipse cx="43" cy="15" rx="2.6" ry="4.2" transform="rotate(35 43 15)" fill="none" stroke="#111" strokeWidth="2.6" />
      <path d="M19 32 Q32 27 45 32 L47 44 Q32 41 17 44 Z" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
      <path d="M17 46 Q15 60 17 74" fill="none" stroke="#111" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M47 46 Q49 60 47 74" fill="none" stroke="#111" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M20 74 Q32 71 44 74 L42 82 Q32 84 22 82 Z" fill="none" stroke="#111" strokeWidth="3" strokeLinejoin="round" />
    </g>
  </svg>
);

export default TopDownCar;
